import React, { useState, useRef, useEffect } from 'react';
import './style.css';

interface TooltipProps {
  title: string;
  description?: string;
}

interface ToolbarButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  active?: boolean;
  tooltip?: TooltipProps;
  // 新增属性，表示按钮是否有展开行为
  hasExpandAction?: boolean;
}

export const ToolbarButton: React.FC<ToolbarButtonProps> = ({
  children,
  onClick,
  active = false,
  tooltip,
  hasExpandAction = false
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const timeoutRef = useRef<number>();

  // 检测设备类型
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleMouseEnter = () => {
    // 移动端不显示 tooltip
    if (isMobile) return;

    // 如果按钮处于激活状态且有展开行为，则不显示tooltip
    if (active && hasExpandAction) return;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = window.setTimeout(() => {
      setShowTooltip(false);
    }, 100);
  };

  // 点击处理 - 在移动端点击后自动关闭tooltip
  const handleClick = () => {
    if (onClick) {
      onClick();
    }

    if (isMobile && showTooltip) {
      setShowTooltip(false);
    }
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <div
      className="toolbar-button-container"
      onMouseEnter={tooltip ? handleMouseEnter : undefined}
      onMouseLeave={tooltip ? handleMouseLeave : undefined}
    >
      <button
        className={`toolbar-button ${active ? 'active' : ''}`}
        onClick={handleClick}
      >
        {children}
      </button>

      {tooltip && showTooltip && !active && !isMobile && (
        <div className="toolbar-tooltip">
          <div className="tooltip-title">{tooltip.title}</div>
          {tooltip.description && (
            <div className="tooltip-description">{tooltip.description}</div>
          )}
        </div>
      )}
    </div>
  );
};